import { ApiMethodKeys, EntityName, SnackbarKeys, notificationsMsgs } from "@sso/constant";
import { closeDialog } from "@sso/store/slices/dialog";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ApiPageResponse, ID, Order, OrderCreateRequest, OrderSummary, OrderUpdateRequest } from "@sso/types";

import { ssoApi } from "..";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const ordersApi = ssoApi
  .enhanceEndpoints({
    addTagTypes: [CacheKeys.ORDERS],
  })
  .injectEndpoints({
    endpoints: builder => ({
      orders: builder.query<ApiPageResponse<OrderSummary>, string>({
        query: query => ({ url: `${Endpoints.ORDERS}?${query}` }),
        providesTags: [CacheKeys.ORDERS],
      }),
      addOrder: builder.mutation<Order, OrderCreateRequest>({
        query: data => ({ url: `${Endpoints.ORDERS}`, method: ApiMethodKeys.POST, data }),
        invalidatesTags: [CacheKeys.ORDERS],
        onQueryStarted(_, { dispatch, queryFulfilled }) {
          queryFulfilled.then(() => {
            dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.ADD_ITEM(EntityName.ORDER) }));
            dispatch(closeDialog());
          });
        },
      }),
      editOrder: builder.mutation<Order, OrderUpdateRequest>({
        query: data => ({ url: `${Endpoints.ORDERS}`, method: ApiMethodKeys.PUT, data }),
        invalidatesTags: [CacheKeys.ORDERS],
        onQueryStarted(_, { dispatch, queryFulfilled }) {
          queryFulfilled.then(() => {
            dispatch(
              pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.Edit_ITEM(EntityName.ORDER) }),
            );
            dispatch(closeDialog());
          });
        },
      }),
      deleteOrder: builder.mutation<void, string>({
        query: orderId => ({ url: Endpoints.ORDERS, params: { orderId }, method: ApiMethodKeys.DELETE }),
        invalidatesTags: [CacheKeys.ORDERS],
        onQueryStarted(_, { dispatch, queryFulfilled }) {
          queryFulfilled.then(() => {
            dispatch(
              pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.DELETE_ITEM(EntityName.ORDER) }),
            );
            dispatch(closeDialog());
          });
        },
      }),
      getOrderById: builder.query<Order, ID>({
        query: orderId => ({ url: `${Endpoints.ORDERS}/${orderId}` }),
        providesTags: [CacheKeys.ORDERS],
        transformResponse: (response: { result: Order }) => {
          if (response.result.expiration) {
            response.result.expiration = new Date(response.result.expiration).toISOString();
          }
          return response.result;
        },
      }),
    }),
  });

export const {
  useOrdersQuery,
  useAddOrderMutation,
  useEditOrderMutation,
  useDeleteOrderMutation,
  useGetOrderByIdQuery,
} = ordersApi;
